// When the GDACS event list is worth asking for again. Pure so it can run under node --test.
export const EVENT_LIST_REFETCH_MS = 30 * 60 * 1000;
export const EVENT_LIST_MIN_AGE_MS = 5 * 60 * 1000;

export const isLiveCyclone = (event) => !!event && event.eventType === 'TC' && event.isCurrent === true;

// Poll only while a live cyclone is selected; everything else keeps the cached list.
export const eventListRefetchInterval = (event) => (isLiveCyclone(event) ? EVENT_LIST_REFETCH_MS : false);

// Revalidate once on open when the cached list is older than the minimum age.
export const shouldRevalidateEvents = ({ event, dataUpdatedAt, nowMs }) =>
  isLiveCyclone(event) && (!dataUpdatedAt || nowMs - dataUpdatedAt >= EVENT_LIST_MIN_AGE_MS);
